import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import {useTranslation} from "react-i18next";
import {Card, CardContent, CardHeader, Divider, Grid, Toolbar,Alert} from "@mui/material";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
// import PlanningSummary from "./PlanningSummary";
import PlanningSend from "./ApprovedSend";
import DoneIcon from "@mui/icons-material/Done";
import { ReactComponent as SendIcon } from "../../assets/images/send.svg";
import { ReactComponent as BtnX } from "../../assets/images/plus-circle-fill.svg";
import planningService from "../../services/planning.service";
import DialogSend from "../../components/DialogSend";
import ConfirmDialog from "../../components/ConfirmDialog";
import MessageDialog from "../../components/inbox/MessageDialog";
import { useDispatch, useSelector } from "react-redux";
import { fetchPlanning } from "../../actions/planning";

const emails = ['username@gmail.com', 'user02@gmail.com'];
function SendToApprove(props) {
    const {t} = useTranslation()
    const planning = props.data;
    const {onClose,dataSummary,datasPlanning,dataPA,serial,statusSend,failed} = props;
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [isSuccessSaveDialogOpen, openSuccessSaveDialog] = React.useState(false);
    const [datasError, setDatasError] = React.useState([]);
    const [sendWranning, setSendWranning] = React.useState([]);

    const handleClose = () => {
        onClose();
    };
    
    const dispatch = useDispatch();
    let remark = ""
    useEffect(() => {
        if (datasPlanning !== undefined && datasPlanning !== null && datasPlanning !== "null" && datasPlanning.length > 0) {
            checkError()
        }
    }, []);
    useEffect(() => {
        displayError()
    }, [datasError]);
    const send = () => {
        planningService.send(serial, remark).then(
            (response) => {
                statusSend()
            }).catch(() => {
                seterrorText('กรุณาส่งขออนุมัติ')
                failed()
            })
    }
    const checkError = () => {
        let error = {}
        let type = []
        if (dataPA.criteria !== undefined && dataPA.criteria !== null && dataPA.criteria !== "") {
            for (let index = 0; index < dataPA.criteria.length; index++) {
                type = dataPA.criteria[index].description
                error = { ...error, [dataPA.criteria[index].serial]: dataPA.criteria[index].description }
            }
        }
        setDatasError(error);
    };
    const displayError = () => {
        let colorError = { color: "#CC6058", background: "#CC60581A" }
        let colorWraning = { color: "#EFAD0A", background: "#EFAD0A1A" }
        let status = ""
        let texts = []
        let text = ""
        if (datasPlanning !== undefined && datasPlanning !== null && datasPlanning !== "") {
            if (dataPA?.validate?.category !== undefined && dataPA?.validate?.category !== null && dataPA?.validate?.category !== "" && Object.keys(dataPA.validate.category).length > 0) {
                for (let indexs = 0; indexs < datasPlanning.length; indexs++) {
                    let categoryData = dataPA?.validate.category[datasPlanning[indexs].serial]
                    if (categoryData !== undefined && categoryData !== null && categoryData !== "") {
                        if (categoryData.length > 0) {
                            for (let index = 0; index <= categoryData.length - 1; index++) {
                                status = categoryData[index].status
                                if (status === "error") {
                                    text = `• คะแนน${datasError[categoryData[index].key]}ไม่เป็นไปตามหลักเกณฑ์ที่กำหนด`
                                } else {
                                    text = `• คะแนน${datasError[categoryData[index].key]}ไม่เป็นไปตามหลักเกณฑ์ที่กำหนด`
                                }
                                if (texts.filter((data)=> data === text).length === 0) {
                                    texts.push(text)
                                }
                            }
                        }
                    }
                }
                setSendWranning(texts)
            }
        }
    }
    return (
        <Grid item lg={12} md={12} m={0} p={3}>
            <Grid item container>
                <Typography variant="h3">
                    {t('planning.label.confirmApprove')}
                </Typography>
                <Box sx={{flex: 1}}/>
                <Box sx={{ position: "absolute", right: 0, margin: "18px 18px 0  0", top: 0, cursor: "pointer" }} onClick={handleClose}><BtnX /></Box>
            </Grid>
            <Grid pt={2}>
                <Divider/>
            </Grid>
            <Grid item pt={4} pb={4} textAlign="center">
                <Typography fontSize={18} fontWeight={300} lineHeight="24.50px">
                    กรุณาตรวจสอบความถูกต้องของคะแนนในแต่ละประเภทข้อตกลงภาระงานอีกครั้งก่อนดำเนินการส่งอนุมัติ
                </Typography>
            </Grid>
                <Grid item lg={12} md={12} pl={4} pr={4}>
                    {sendWranning.length > 0 ?
                    (
                        <Alert
                            icon={false}
                            sx={{color: "#EFAD0A", background: "#EFAD0A1A"}}
                        >
                            {sendWranning.map((item) => ( 
                                <Typography>
                                    {item}
                                </Typography>
                            ))
                            }
                        </Alert>
                    )
                        : null
                    }
                </Grid>
            <Grid item textAlign="center" p={4}>
                <PlanningSend dataSummary={dataSummary} datasPlanning={datasPlanning} dataPA={dataPA} />
            </Grid>
            <Grid item container pt={4} pb={4} justifyContent="center">
                <Grid lg={6} xs={6} item container spacing={2}>
                    <Grid item lg={6} xs={6}>
                        <Button
                            color="primary"
                            fullWidth
                            size="large"
                            variant="dashed-solid"
                            sx={{padding: "8px 20px"}}
                            onClick={handleClose}
                        >
                            {t('label.cancel')}
                        </Button>
                    </Grid>
                    <Grid item lg={6} xs={6}>
                        <Button
                            color="primary"
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                            onClick={send}
                        >
                            {t('label.confirm')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
function SimpleDialog(props) {
    const {onClose, selectedValue, open,dataSummary,datasPlanning,dataPA,serial,sendData,fail} = props;
    const handleClose = () => {
        onClose(selectedValue);
    };
    const handleListItemClick = (value) => {
        onClose(value);
    };
    const statusSend = () => {
        sendData()
    }
    const failed = () => {
        fail()
    }
    return (
         <Dialog onBackdropClick={() => {return false}} onClose={handleClose} open={open} maxWidth='lg' fullWidth>
            <SendToApprove onClose={handleListItemClick} dataSummary={dataSummary} datasPlanning={datasPlanning} dataPA={dataPA} serial={serial} statusSend={statusSend} failed={failed} />
        </Dialog>
    );
}
SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};
export default function DialogSendToApprove(props) {
    const {t} = useTranslation();
    const [open, setOpen] = React.useState(false);
    const {status,dataSummary,datasPlanning,dataPA,serial,textWarning} = props;
    const [selectedValue, setSelectedValue] = React.useState(emails[1]);
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [isSuccessSaveDialogOpen, openSuccessSaveDialog] = React.useState(false);
    const dispatch = useDispatch();
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = (value) => {
        setOpen(false);
        setSelectedValue(value);
    };
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const sendData = () => {
        openSuccessSaveDialog(true)
        setOpen(false);
    }
    const fail = () => {
        handleCloseFailedMessageDialog(true)
        setOpen(false);
    }
    const setValue = () => {
        dispatch(fetchPlanning(serial))
        openSuccessSaveDialog(false)
    }
    return (
        <div>
            {status ?
            <Button startIcon={<SendIcon/>} size="medium" variant="contained" onClick={handleClickOpen}>{t('label.sendToApprove')}</Button>
            :
            <Button startIcon={<SendIcon/>} sx={{cursor: "no-drop", backgroundColor: "#BABABA", pointerEvents: "none"}} size="medium" variant="contained">{t('label.sendToApprove')}</Button>
            }
            <SimpleDialog
                selectedValue={selectedValue}
                open={open}
                onClose={handleClose}
                dataSummary={dataSummary}
                datasPlanning={datasPlanning}
                dataPA={dataPA}
                serial={serial}
                textWarning={textWarning}
                sendData={sendData}
                fail={fail}
            />
            <DialogSend open={isSuccessSaveDialogOpen} setValue={setValue} save={true} text="สามารถตรวจสอบสถานะของการดำเนินการส่งอนุมัติ" />
            <MessageDialog open={openFailedMessageDialog} setValue={handleCloseFailedMessageDialog} type="fail" title="ดำเนินการไม่สำเร็จ" text={errorText + " \nใหม่อีกครั้ง"} />
        </div>
    );
}
